// The Portal's website session is independent of the scanner's Go-owned account.
// Microsoft interactive sign-in must use a top-level popup when Portal is framed.
const MESSAGE = 'pipsqueak.portal.microsoft-sign-in';
const REQUEST = /^[a-f0-9]{32}$/;

export function completeMicrosoftPopup({ browser = window, token, error }) {
    const request = new URLSearchParams(browser.location.search).get('sso_popup');
    if (!REQUEST.test(request || '') || !browser.opener) return false;
    browser.opener.postMessage({ type: MESSAGE, request, token, error }, browser.location.origin);
    browser.history.replaceState(null, '', browser.location.pathname);
    browser.close();
    return true;
}

export function startMicrosoftPopup({ browser = window, onSuccess, onError, onPending, timeoutMs = 600000 }) {
    const request = Array.from(browser.crypto.getRandomValues(new Uint8Array(16)), n => n.toString(16).padStart(2, '0')).join('');
    const origin = browser.location.origin;
    const target = new URL('/s1/api/auth/entra/start', origin);
    target.searchParams.set('popup_request', request);
    let popup; let interval; let timeout; let done = false; let closedChecks = 0;
    const cleanup = () => {
        browser.removeEventListener('message', message);
        browser.clearInterval(interval); browser.clearTimeout(timeout);
        onPending(false);
    };
    const finish = (token, error) => {
        if (done) return;
        done = true; cleanup();
        try { popup?.close(); } catch { /* It may already be closed. */ }
        if (error) onError(error); else onSuccess(token);
    };
    const message = event => {
        const data = event.data;
        if (!popup || event.origin !== origin || event.source !== popup || !data || data.type !== MESSAGE || data.request !== request) return;
        if (typeof data.error === 'string') return finish(null, data.error);
        if (typeof data.token !== 'string' || !data.token || data.token.length > 65536) return finish(null, 'auth_failed');
        finish(data.token);
    };
    onPending(true);
    browser.addEventListener('message', message);
    try { popup = browser.open(target.href, '_blank', 'popup=yes,width=520,height=720'); }
    catch { finish(null, 'popup_blocked'); return null; }
    if (!popup) { finish(null, 'popup_blocked'); return null; }
    // Two observations give a queued callback message time to arrive after close().
    interval = browser.setInterval(() => {
        try { closedChecks = popup.closed ? closedChecks + 1 : 0; } catch { closedChecks = 0; }
        if (closedChecks >= 2) finish(null, 'cancelled');
    }, 500);
    timeout = browser.setTimeout(() => finish(null, 'timed_out'), timeoutMs);
    return () => { if (done) return; done = true; cleanup(); try { popup.close(); } catch {} };
}
